import cn from 'classnames'
import { PrimaryButton } from '../PrimaryButton'
import React, { useState } from 'react'
import { PricesMobileSearchPhrases } from '../../sections/PricesMobileSearchPhrases'
import { SelectableCard } from '../SelectableCard'
import { TooltipIcon } from '../TooltipIcon'
import { ToggleCard } from '../ToggleCard'
import { SelectableTariffDropdown } from '../SelectableTariffDropdown'
import { CostListRepricerAdditionalInfo } from './CostListRepricerAdditionalInfo'
const TOOLTIP_TEXT = {
  products:
    'Считаем все товары в наличии по добавленным ключам. Количество магазинов не ограничено',
  marketplaces:
    'Количество маркетплейсов, где есть хотя бы один ваш товар в наличии',
  addons: (
    <>
      <strong>Премиум-поддержка</strong>
      <div className="mt-1">
        Выделенный чат с нашей командой. Среднее время ответа — 15 минут. Без
        премиума ответы до 6 часов
      </div>
      <div className="mt-4">
        {' '}
        <strong>Персональное сопровождение</strong>
        <div className="mt-1">
          Персональное обучение. Подскажем как лучше настроить репрайсеры для
          вашего бизнеса. Неограниченные созвоны в течение первого месяца, чтобы
          вы быстро освоили сервис
        </div>
      </div>
    </>
  ),
  support:
    'Выделенный чат с нашей командой. Среднее время ответа — 15 минут. Без премиума ответы до 6 часов',
  training:
    'Персональное обучение. Подскажем как лучше настроить репрайсеры для вашего бизнеса. Неограниченные созвоны в течение первого месяца, чтобы вы быстро освоили сервис'
}

const getDiscountPercent = periodIndex => {
  if (periodIndex === 0) return 0
  return (10 + (periodIndex - 1) * 5) / 100
}

export const CostListRepricer = ({
  tariffs: tariffsData,
  extraPrices,
  activePeriod,
  setActivePeriod
}) => {
  const tariffsReceived = tariffsData.sort((a, b) =>
    a.count_products > b.count_products ? 1 : -1
  )
  const tariffs = [
    ...tariffsReceived,
    {
      id: 9999,
      name: 'Свыше 15000',
      count_products: 1001,
      price: -1,
      periods: [
        {
          id: 1,
          name: '1 месяц',
          price_month: -1,
          price_total: -1
        },
        {
          id: 3,
          name: '3 месяца',
          price_month: -1,
          price_total: -1
        },
        {
          id: 6,
          name: '6 месяцев',
          price_month: -1,
          price_total: -1
        },
        {
          id: 12,
          name: '12 месяцев',
          price_month: -1,
          price_total: -1
        }
      ]
    }
  ]

  const MARKETPLACE_ITEMS = [
    { count: 1, title: '1 маркетплейс', priceDelta: 0 },
    {
      count: 2,
      title: '2 маркетплейса',
      priceDelta: extraPrices?.extra_site_price || 0
    },
    {
      count: 3,
      title: '3 маркетплейса',
      priceDelta: extraPrices?.extra_site_price * 2 || 0
    }
  ]

  const ADDON_ITEMS = [
    {
      key: 'connect',
      title: 'Премиум поддержка',
      priceDelta: extraPrices?.premium_support_price || 0,
      defaultSelected: false,
      tooltipText: TOOLTIP_TEXT.support
    },
    {
      key: 'training',
      title: 'Персональное сопровождение',
      priceDelta: extraPrices?.training_price || 0,
      defaultSelected: false,
      tooltipText: TOOLTIP_TEXT.training
    }
  ]

  const [activeCount, setActiveCount] = useState(
    tariffs[0] && tariffs[0].count_products
  )
  const [activeFreq, setActiveFreq] = useState()
  const [marketplaceCount, setMarketplaceCount] = useState(
    MARKETPLACE_ITEMS[0].count
  )
  const [selectedAddons, setSelectedAddons] = useState(
    new Set(ADDON_ITEMS.filter(a => a.defaultSelected).map(a => a.key))
  )

  const tariff = tariffs.find(
    ({ count_products }) => count_products === activeCount
  )
  const tariffPrice =
    (tariff && tariff.price) === -1 ? 0 : tariff && tariff.price
  const searched =
    tariff &&
    tariff.periods &&
    tariff.periods.find(el => el.id === activePeriod)
  const total = (searched && searched.price_total) || 0
  const priceMonth = (searched && searched.price_month) || 0
  const idMonth = (searched && searched.id) || 0
  const activeTariff = tariffs.find(el => el.count_products === activeCount)

  const periodIndex =
    activeTariff && activeTariff.periods ?
      activeTariff.periods
        .filter((el, idx) => !(activeCount === 10 && idx !== 0))
        .findIndex(period => period.id === activePeriod)
    : -1
  const discountPercent = getDiscountPercent(periodIndex)

  const marketplaceItem =
    MARKETPLACE_ITEMS.find(i => i.count === marketplaceCount) ||
    MARKETPLACE_ITEMS[0]
  const marketplaceDeltaPerMonth = marketplaceItem?.priceDelta || 0

  const addonsTotal = Array.from(selectedAddons).reduce((sum, key) => {
    const found = ADDON_ITEMS.find(a => a.key === key)
    return sum + (found ? found.priceDelta : 0)
  }, 0)

  const discountedMarketplaceMonthly =
    marketplaceDeltaPerMonth * (1 - discountPercent)

  const discountedBaseMonthly = total / idMonth

  const discountedRepricerMonthly =
    discountedBaseMonthly + discountedMarketplaceMonthly

  const discountedMarketplaceTotal = discountedMarketplaceMonthly * idMonth
  const totalFinal = total + discountedMarketplaceTotal + addonsTotal

  return (
    <div id="tariffs" className="w-full max-w-[1200px]">
      <div className="bg-[#1B2126] rounded-t-[20px] rounded-b-[10px] lg:rounded-t-[60px] lg:rounded-b-[30px] py-5 lg:p-20 mt-[49px] lg:mt-5 relative">
        <div className="hidden lg:flex space-x-10 justify-between">
          <div className="flex flex-grow max-w-[230px] min-w-[230px]">
            <div className="space-y-8 flex-grow">
              <div className="rounded-[100px] pt-[18px] px-6 pb-4 border border-white/[12%] w-fit">
                <span className="block text-white text-sm leading-[16px] font-semibold">
                  ШАГ 1
                </span>
              </div>
              <div>
                <div className="flex items-center gap-2 mb-3 justify-between">
                  <span className="block text-white font-medium text-lg whitespace-nowrap leading-[34px]">
                    Товаров в наличии
                  </span>
                  <TooltipIcon text={TOOLTIP_TEXT.products} />
                </div>
                <div className="h-0.5 bg-white/[7%]" />
              </div>

              <SelectableTariffDropdown
                options={tariffs.map(tariff => {
                  const { name, price, count_products } = tariff
                  const resultName = name.split(' ')
                  if (Number.isInteger(+resultName[0])) {
                    resultName[0] = (+resultName[0]).toLocaleString('ru')
                  }
                  return {
                    value: count_products,
                    label: resultName.join(' '),
                    price: price
                  }
                })}
                value={activeCount}
                selectedPrice={tariffPrice}
                onChange={value => {
                  setActiveFreq(1)
                  setActiveCount(value)
                }}
                placeholder="Выберите количество товаров"
              />
            </div>
          </div>

          {/* ШАГ 2 */}
          <div className="flex flex-grow max-w-[230px] min-w-[230px]">
            <div className="space-y-8 flex-grow">
              <div className="rounded-[100px] pt-[18px] px-6 pb-4 border border-white/[12%] w-fit">
                <span className="block text-white text-sm leading-[16px] font-semibold">
                  ШАГ 2
                </span>
              </div>
              <div>
                <div className="flex items-center gap-2 mb-3 justify-between">
                  <span className="block text-white font-medium text-lg whitespace-nowrap leading-[34px]">
                    Маркетплейсов
                  </span>
                  <TooltipIcon text={TOOLTIP_TEXT.marketplaces} />
                </div>
                <div className="h-0.5 bg-white/[7%]" />
              </div>
              <div className="space-y-4">
                {MARKETPLACE_ITEMS.map(item => {
                  const isChecked = marketplaceCount === item.count
                  const subtitle =
                    item.priceDelta === 0 ?
                      'Бесплатно'
                    : item.priceDelta.toLocaleString('ru') + ' ₽'
                  return (
                    <SelectableCard
                      key={`marketplace-${item.count}`}
                      title={item.title}
                      subtitle={subtitle}
                      checked={isChecked}
                      onChange={() => setMarketplaceCount(item.count)}
                    />
                  )
                })}
              </div>
            </div>
          </div>

          {/* ШАГ 3 */}
          <div className="flex flex-grow max-w-[230px] min-w-[230px]">
            <div className="space-y-8 flex-grow">
              <div className="rounded-[100px] pt-[18px] px-6 pb-4 border border-white/[12%] w-fit">
                <span className="block text-white text-sm leading-[16px] font-semibold">
                  ШАГ 3
                </span>
              </div>
              <div>
                <div className="flex items-center gap-2 mb-3 justify-between">
                  <span className="block text-white font-medium text-lg whitespace-nowrap leading-[34px]">
                    Доп. опции
                  </span>
                  <TooltipIcon text={TOOLTIP_TEXT.addons} />
                </div>
                <div className="h-0.5 bg-white/[7%]" />
              </div>
              <div className="space-y-4">
                {ADDON_ITEMS.map(item => {
                  const isOn = selectedAddons.has(item.key)
                  const toggle = () => {
                    setSelectedAddons(prev => {
                      const next = new Set(prev)
                      if (next.has(item.key)) {
                        next.delete(item.key)
                      } else {
                        next.add(item.key)
                      }
                      return next
                    })
                  }
                  return (
                    <ToggleCard
                      key={`addon-${item.key}`}
                      title={item.title}
                      subtitle={`${item.priceDelta.toLocaleString('ru')} ₽`}
                      checked={isOn}
                      onChange={toggle}
                      tooltipText={item.tooltipText}
                    />
                  )
                })}
              </div>
            </div>
          </div>

          <div className="flex flex-grow max-w-[230px] min-w-[230px]">
            <div className="space-y-8 flex-grow">
              <div className="rounded-[100px] pt-[18px] px-6 pb-4 border border-white/[12%] w-fit">
                <span className="block text-white text-sm leading-[16px] font-semibold">
                  ШАГ 4
                </span>
              </div>
              <div>
                <div className="flex items-center gap-2 mb-3 justify-between">
                  <span className="block text-white font-medium text-lg whitespace-nowrap leading-[34px]">
                    Период действия
                  </span>
                </div>
                <div className="h-0.5 bg-white/[7%]" />
              </div>
              <div className="space-y-4">
                {activeTariff &&
                  activeTariff.periods
                    .filter((el, index) => !(activeCount === 10 && index !== 0))
                    .map((period, index) => {
                      const { name, id } = period
                      const isChecked = id === activePeriod
                      return (
                        <SelectableCard
                          key={id + name}
                          title={name}
                          badge={
                            index !== 0 ?
                              <span className="block text-white text-[12px] px-1 leading-[22px] rounded-[7px] bg-[#C93F38] font-semibold">{`- ${10 + (index - 1) * 5} %`}</span>
                            : null
                          }
                          checked={isChecked}
                          onChange={() => setActivePeriod(id)}
                        />
                      )
                    })}
              </div>
            </div>
          </div>
        </div>
        <PricesMobileSearchPhrases
          tariffPrice={tariffPrice}
          activePeriod={activePeriod}
          setActivePeriod={setActivePeriod}
          tariffs={tariffs}
          tariff={tariff}
          idMonth={idMonth}
          priceMonth={priceMonth}
          total={totalFinal}
          totalBase={total}
          activeCount={activeCount}
          activeFreq={activeFreq}
          setActiveCount={setActiveCount}
          setActiveFreq={setActiveFreq}
          addonItems={ADDON_ITEMS}
          selectedAddons={selectedAddons}
          setSelectedAddons={setSelectedAddons}
          marketplaceItems={MARKETPLACE_ITEMS}
          marketplaceCount={marketplaceCount}
          setMarketplaceCount={setMarketplaceCount}
        />

        <div className="hidden lg:flex justify-end gap-6 border-t border-white/[12%] pt-10 mt-10 ">
          <div className="w-full lg:w-2/5">
            <span className="block text-white text-4xl font-medium">
              Итого стоимость:
            </span>
          </div>
          <div className="w-full lg:w-3/5">
            <div>
              <span
                className={cn(
                  'block flex justify-between w-full items-baseline text-[#9DCF4E] text-base font-normal leading-[23px]',
                  {
                    '-tracking-[2px]': activeCount === 1001
                  }
                )}
              >
                {activeCount !== 1001 && (
                  <div className="flex justify-between items-baseline w-full">
                    <span className="text-lg">Репрайсер в месяц</span>
                    <span className="dots grow h-[2px] bg-[repeating-linear-gradient(90deg,_#9DCF4E,_#9DCF4E_2px,_transparent_2px,_transparent_6px)]" />
                    <span className="text-2xl">
                      {discountedRepricerMonthly.toLocaleString('ru')} ₽
                    </span>
                  </div>
                )}
              </span>
              <span
                className={cn(
                  'block flex justify-between w-full items-baseline text-[#9DCF4E] text-base font-normal leading-[23px]',
                  {
                    '-tracking-[2px]': activeCount === 1001
                  }
                )}
              >
                {activeCount === 1001 && (
                  <div className="flex justify-between items-baseline w-full">
                    <span className="text-lg">Доп. опции</span>
                    <span className="dots grow h-[2px] bg-[repeating-linear-gradient(90deg,_#9DCF4E,_#9DCF4E_2px,_transparent_2px,_transparent_6px)]" />
                    <span className="text-2xl">
                      {addonsTotal.toLocaleString('ru')} ₽
                    </span>
                  </div>
                )}
              </span>
              <span
                className={cn(
                  'block flex justify-between w-full items-baseline text-[#9DCF4E] text-5xl font-normal leading-[47px]',
                  {
                    '-tracking-[2px]': activeCount === 1001,
                    '!text-[32px]':
                      (totalFinal &&
                        totalFinal.toLocaleString('ru').length > 5) ||
                      (totalFinal && totalFinal >= 2000) ||
                      activeCount === 1001
                  }
                )}
              >
                {activeCount === 1001 ?
                  'Персонально'
                : <div className="flex justify-between items-baseline w-full">
                    <span className="text-lg">
                      Всего за {idMonth}{' '}
                      {idMonth === 1 ?
                        'месяц'
                      : idMonth < 5 ?
                        'месяца'
                      : 'месяцев'}
                    </span>
                    <span className="dots grow h-[2px] bg-[repeating-linear-gradient(90deg,_#9DCF4E,_#9DCF4E_2px,_transparent_2px,_transparent_6px)]" />
                    <span className="text-3xl">
                      {totalFinal.toLocaleString('ru')} ₽
                    </span>
                  </div>
                }
              </span>
            </div>
          </div>
        </div>
        <CostListRepricerAdditionalInfo />
      </div>

      <div className=" mt-10 text-center">
        <PrimaryButton
          className="w-full lg:w-fit py-10 px-10 lg:py-20 lg:px-24"
          onClick={() =>
            (window.location.href = 'https://go.priceninja.ru/products')
          }
        >
          <span className="block font-semibold lg:font-medium text-[18px] leading-[21px] lg:text-6xl lg:leading-[38px] lg:-tracking-[1px] text-center text-white">
            Мне все нравится, начинаем!
          </span>
        </PrimaryButton>
      </div>
    </div>
  )
}
